/**
 * useTaxonomy Hook
 * React Query hook for fetching taxonomy reference data
 */

import { useQuery } from '@tanstack/react-query';
import { normalizeTaxonomyOptions, taxonomyApi, type TaxonomyOption } from '../services/taxonomyApi';

/**
 * Fetch categories
 */
export function useCategories() {
  return useQuery<TaxonomyOption[], Error>({
    queryKey: ['taxonomy', 'categories'],
    queryFn: () => taxonomyApi.getCategories(),
    select: (data) => normalizeTaxonomyOptions(data, 'categories'),
    staleTime: 1000 * 60 * 60, // 1 hour (reference data rarely changes)
  });
}

/**
 * Fetch specialties
 * @param categoryId - Optional category ID to filter specialties
 */
export function useSpecialties(categoryId?: string) {
  return useQuery<TaxonomyOption[], Error>({
    queryKey: ['taxonomy', 'specialties', categoryId],
    queryFn: () => taxonomyApi.getSpecialties(categoryId),
    select: (data) => normalizeTaxonomyOptions(data, 'specialties'),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
}

/**
 * Fetch expertise
 */
export function useExpertise() {
  return useQuery<TaxonomyOption[], Error>({
    queryKey: ['taxonomy', 'expertise'],
    queryFn: () => taxonomyApi.getExpertise(),
    select: (data) => normalizeTaxonomyOptions(data, 'expertise'),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
}

